import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { BugReport, EditOutlined, Notes } from '@mui/icons-material';
import { FilterBar, TableData, TxnLogView } from '../../../components';
import { errorAlert } from '../../../helpers/alerts';
import { getAclaracionesService, getTasksService } from '../../../services/admin/taskService';
import { setCurrentTask, setTasks } from '../../../redux/slices/admin/taskSlice';
import moment from 'moment';
import { getLogsTxnService } from 'services/panelService';
import DialogModal from 'components/modal/DialogModal';

const AclaracionesScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { tasks } = useSelector(store => store.task);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [loading, setLoading] = useState(false);
  const [dialog, setDialog] = useState({ open: false, title: '', body: '' });

  const handlerEdit = (data) => {
    dispatch(setCurrentTask(data));
    navigate("../editar");
  };

  const handlerSubmit = (data) => {
    setLoading(true);
    data.page = page;
    data.limit = rowsPerPage;
    getAclaracionesService(data).then((response) => {
      dispatch(setTasks(response))
    }).catch(error => errorAlert(error))
      .finally(() => setLoading(false));
  }

  const sortedTasks = [...tasks].sort((a, b) => {
    const order = { "Pendiente": 0, "En proceso": 1, "Finalizada": 2 };
    const stateDiff = (order[a.state] ?? 3) - (order[b.state] ?? 3);
    if (stateDiff !== 0) return stateDiff;
    return new Date(b.createdAt) - new Date(a.createdAt);
  });
  console.log(sortedTasks);

  return (
    <>
      <FilterBar
        handlerFilter={handlerSubmit}
        page={page}
        limit={rowsPerPage}
        showTitle={false}
        defaultValues={{
          state: ["Pendiente", "En proceso"],
        }}
        filters={[
          {
            name: "state",
            label: "Estado",
            type: "select",
            multiple: true,
            data: [
              { id: "Pendiente", name: "Pendiente" },
              { id: "En proceso", name: "En proceso" },
              { id: "Finalizada", name: "Finalizada" },
            ],
          },
        ]}
      />
      <TableData
        dataRows={sortedTasks}
        loading={loading}
        onChangePage={page => setPage(page)}
        onChangeRowsPerPage={rowsPerPage => setRowsPerPage(rowsPerPage)}
        dataTitle={[
          "Origen",
          "Fecha",
          "Instancia",
          "Autorización",
          "Número",
          "Monto",
          "Estado Txn",
          "Código",
          "Estado",
          "Observaciónes",
          "Cierre"
        ]}
        formatter={({ origin, createdAt, credential, phoneNumber, auth, amount, txnState, code, state, notes, closeDate }) => [
          origin, 
          moment(createdAt).format("DD/MM/YYYY HH:mm"),
          credential?.name_connector,
          auth,
          phoneNumber,
          amount,
          txnState,
          code,
          state,
          notes && {
            type: "img",
            value: <Notes />,
            title: notes
          },
          closeDate ? moment(closeDate).format("DD/MM/YYYY HH:mm") : "-"
        ]}
        actions={[
          {
            label: "Editar",
            icon: <EditOutlined />,
            onClick: (data) => {
              handlerEdit(data);
            },
          },
          {
            label: "Logs",
            icon: <BugReport />,
            validate: ({ origin, operationId }) => origin == 'HEBE' && operationId,
            onClick: async (data) => {
              const result = await getLogsTxnService(data.operationId);
              setDialog({
                open: true,
                maxWidth: 'lg',
                title: `Log Transacción ${data.operationId}`,
                textAlign: 'left',
                body: <TxnLogView data={result} />,
                onClose: () => setDialog({ open: false })
              })
            },
          },
        ]}
      />
      <DialogModal
        open={dialog.open}
        title={dialog.title}
        body={dialog.body}
        maxWidth={dialog.maxWidth}
        textAlign={dialog.textAlign}
        onSuccess={dialog.onSuccess}
        onClose={dialog.onClose}
      />
    </>
  )
}

export default AclaracionesScreen